{
  "title_payment": "Payment records",
  "title_receipt": "Collection records",
  "title_application_receipt": "Receipt records",
  "title_deposit_receipt": "Deposit receipt records",
  "title_deposit_refund": "Deposit refund records",
  "title_tax_refund": "Tax refund receipt records",
  "voucher_payment": "Payment voucher",
  "voucher_receipt": "Collection voucher",
  "voucher_application_receipt": "Receipt voucher",
  "voucher_deposit_receipt": "Deposit receipt voucher",
  "voucher_deposit_refund": "Deposit refund voucher",
  "voucher_tax_refund": "Tax refund voucher",
  "empty": "No {{title}}",
  "close": "Close",
  "view": "View {{title}}: {{amount}}",
  "loading": "Loading {{title}}…",
  "load_error": "Unable to load {{title}}",
  "retry_hint": "Please retry. No business data will be changed.",
  "retry": "Retry",
  "scope_summary": "Whole-scope fund summary",
  "settled_amount": "Source settled amount",
  "recorded_amount": "All recorded amounts",
  "batch_count": "{{count}} batches",
  "transaction_no": "Fund transaction number",
  "scope_amount": "Vehicle allocation in this batch",
  "vehicle_hint": "Vehicle amounts are allocated by batch. Bank details retain the full transaction amounts, not per-vehicle bank allocations.",
  "inconsistent": "Fund summary and records do not match",
  "inconsistent_hint": "The summary amount is missing matching records or a source. Contact an administrator to verify it; no balancing records will be created here."
}
